export default "__VITE_ASSET__Bwmjeggb__"